import { useFeatureFlagEnabled as _useFeatureFlagEnabled } from "@posthog/react";

/**
 * Centralized PostHog feature flag keys.
 * Add new feature flag keys here as string literals.
 */
export const featureFlags = {
	testMode: "testMode",
} as const;

export type FeatureFlagKey = (typeof featureFlags)[keyof typeof featureFlags];

/**
 * Typed wrapper around PostHog's `useFeatureFlagEnabled` that only accepts known flag keys.
 */
export const useFeatureFlagEnabled = (key: FeatureFlagKey) =>
	_useFeatureFlagEnabled(key);
